document.addEventListener("DOMContentLoaded", function () {
  const tooltipWrappers = document.querySelectorAll('.pdp-tooltip-wrapper');
  const gallery = document.querySelector('.product__images');
  const badgeContainers = document.querySelectorAll('.product-badge-container');
  const badges = document.querySelectorAll('.product-badge');

  // Tooltip behavior for touch devices
  tooltipWrappers.forEach(wrapper => {
    const trigger = wrapper.querySelector('.pdp-tooltip-trigger');
    const bubble = wrapper.querySelector('.pdp-tooltip__bubble');
    const link = wrapper.querySelector('.pdp-tooltip__link');

    if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
      // Tapping the icon/text shows the bubble
      trigger.addEventListener('click', function (e) {
        if (!wrapper.classList.contains('touch-active')) {
          e.preventDefault();
          tooltipWrappers.forEach(w => {
            if (w !== wrapper) w.classList.remove('touch-active');
          });
          wrapper.classList.add('touch-active');
        } else if (!bubble.contains(e.target) && !link.contains(e.target)) {
          wrapper.classList.remove('touch-active');
        }
      });

      // Allow the link to behave normally
      link.addEventListener('click', function (e) {
        e.stopPropagation(); // Prevents the wrapper from closing before the link works
        wrapper.classList.remove('touch-active'); // Optional: close after clicking
      });

      // Tapping outside any tooltip closes all
      document.addEventListener('click', function (e) {
        if (!wrapper.contains(e.target)) {
          wrapper.classList.remove('touch-active');
        }
      });
    }
  });

  // Move badges into image gallery
  badgeContainers.forEach(badge => {
    if (gallery && badge) gallery.appendChild(badge);
  });

  // Badge toggle for mobile touch
  badges.forEach(function (badge) {
    badge.addEventListener('touchstart', function (e) {
      e.stopPropagation();
      badges.forEach(b => b.classList.remove('active'));
      badge.classList.toggle('active');
    });
  });

  // Dismiss badges if tapping outside
  document.addEventListener('touchstart', function (e) {
    if (![...badges].some(b => b.contains(e.target))) {
      badges.forEach(b => b.classList.remove('active'));
    }
  });
});
